"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styles = require("@material-ui/core/styles");

var _index = _interopRequireDefault(require("./index"));

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, children);
};

ThemeProvider.defaultProps = {
  theme: _index.default
};
ThemeProvider.propTypes = {
  /** The root component that will use Propulsion components in its tree. */
  children: _propTypes.node.isRequired,

  /** The Propulsion theme in case you want to override it, it will use the default one if not provided. */
  theme: _propTypes.object
};
var _default = ThemeProvider;
exports.default = _default;
